"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FrontendLocaleManager = require("./lib/FrontendLocaleManager");

var _FrontendLocaleManager2 = _interopRequireDefault(_FrontendLocaleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FrontendLocaleManager2.default; /**
                                                    * Copyright 2013-present, Novivia, Inc.
                                                    * All rights reserved.
                                                    */

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/localization/FrontendLocaleManager.js
// module id = 692
// module chunks = 6